import { BROWSER_PRINT_ERRORS } from "../../../utils/browserPrint"

// Provisional texts, to be validated with the workshop (KFC-580, Q2)
const ERROR_MESSAGES = {
  [BROWSER_PRINT_ERRORS.ABSENT]: "Browser Print est injoignable. Vérifiez que l'application Zebra Browser Print est lancée sur la tablette et que Chrome a le droit d'y accéder, puis actualisez.",
  [BROWSER_PRINT_ERRORS.NO_RESPONSE]: "Browser Print ne répond pas. Acceptez la demande d'autorisation affichée par Chrome ou par Browser Print s'il y en a une, sinon relancez Zebra Browser Print, puis actualisez.",
  [BROWSER_PRINT_ERRORS.NO_PRINTER]: "Aucune imprimante détectée. Vérifiez qu'elles sont allumées, puis actualisez.",
  [BROWSER_PRINT_ERRORS.PRINTER_NO_RESPONSE]: "L'imprimante ne répond pas. Vérifiez qu'elle est allumée et connectée, puis actualisez la liste."
}

const PRINTER_PROBLEM_MESSAGES = {
  paperOut: "Plus de papier : rechargez le rouleau.",
  headOpen: "Tête d'impression ouverte : refermez le capot.",
  ribbonOut: "Plus de ruban : remplacez-le.",
  paused: "Imprimante en pause : appuyez sur le bouton pause."
}

export const PRINT_MESSAGES = {
  printerNotFound: "Imprimante introuvable. Vérifiez qu'elle est allumée puis actualisez, ou choisissez-en une autre.",
  noPrinterSelected: "Choisissez une imprimante.",
  searching: "Recherche des imprimantes en cours, réessayez dans un instant.",
  labelsNotReady: "Étiquettes en cours de préparation, réessayez dans un instant."
}

export function getPrintErrorMessage(error) {
  return ERROR_MESSAGES[error?.code] || ERROR_MESSAGES[BROWSER_PRINT_ERRORS.PRINTER_NO_RESPONSE]
}

/** Message naming every problem that blocks the printer, or "" when it is ready */
export function getPrinterProblemMessage(status) {
  return Object.keys(PRINTER_PROBLEM_MESSAGES)
    .filter(problem => status?.[problem])
    .map(problem => PRINTER_PROBLEM_MESSAGES[problem])
    .join(" ")
}

export function getPrintSuccessMessage(labelCount, printerLabel) {
  const labels = labelCount > 1 ? `${labelCount} étiquettes envoyées` : `${labelCount} étiquette envoyée`
  return `${labels} à ${printerLabel}.`
}
